import { Link } from "react-router-dom";
import Logo from "./Logo";
import { t } from "../i18n";
import { cities, staticPath, pagePath, hubs, hubPath } from "../data";

export default function Footer({ lang }) {
  const i = t[lang];
  const featured = cities.slice(0, 6);

  return (
    <footer className="mt-24 bg-petrol text-white" data-testid="site-footer">
      <div className="container-site py-16 md:py-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo lang={lang} light />
            <p className="mt-6 max-w-sm font-editorial text-2xl italic text-white/90">{i.footer.tagline}</p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/70">{i.footer.desc}</p>
          </div>
          <div className="md:col-span-2">
            <h2 className="text-xs font-bold uppercase tracking-widest text-white/50">{i.footer.explore}</h2>
            <ul className="mt-5 space-y-3 text-sm">
              {featured.map((c) => (
                <li key={c.id}>
                  <Link to={pagePath(lang, c)} data-testid={`footer-dest-${c.id}`} className="text-white/80 transition-colors duration-200 hover:text-ember">
                    {c.name[lang]}
                  </Link>
                </li>
              ))}
              <li>
                <Link to={staticPath(lang, "carRental")} data-testid="footer-all-destinations" className="font-semibold text-ember transition-colors duration-200 hover:text-white">
                  {i.nav.destinations} →
                </Link>
              </li>
              <li>
                <Link to={hubPath(lang, hubs.italia)} data-testid="footer-hub-italy" className="text-white/80 transition-colors duration-200 hover:text-ember">
                  {lang === "it" ? "Noleggio auto in Italia" : "Car rental in Italy"}
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <h2 className="text-xs font-bold uppercase tracking-widest text-white/50">{i.footer.company}</h2>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to={staticPath(lang, "about")} data-testid="footer-about" className="text-white/80 transition-colors duration-200 hover:text-ember">{i.nav.about}</Link></li>
              <li><Link to={staticPath(lang, "contact")} data-testid="footer-contact" className="text-white/80 transition-colors duration-200 hover:text-ember">{i.nav.contact}</Link></li>
              <li><Link to={staticPath(lang, "help")} data-testid="footer-help" className="text-white/80 transition-colors duration-200 hover:text-ember">{i.nav.help}</Link></li>
              <li><Link to={staticPath(lang, "airports")} data-testid="footer-airports" className="text-white/80 transition-colors duration-200 hover:text-ember">{i.nav.airports}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h2 className="text-xs font-bold uppercase tracking-widest text-white/50">{i.footer.legal}</h2>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to={staticPath(lang, "privacy")} data-testid="footer-privacy" className="text-white/80 transition-colors duration-200 hover:text-ember">{lang === "it" ? "Informativa Privacy" : "Privacy Policy"}</Link></li>
              <li><Link to={staticPath(lang, "cookies")} data-testid="footer-cookies" className="text-white/80 transition-colors duration-200 hover:text-ember">Cookie Policy</Link></li>
              <li><Link to={staticPath(lang, "terms")} data-testid="footer-terms" className="text-white/80 transition-colors duration-200 hover:text-ember">{lang === "it" ? "Termini e Condizioni" : "Terms & Conditions"}</Link></li>
              <li><Link to={staticPath(lang, "affiliate")} data-testid="footer-affiliate" className="text-white/80 transition-colors duration-200 hover:text-ember">{i.footer.disclosure}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 border-t border-white/15 pt-8 text-xs text-white/50">
          <p>© {new Date().getFullYear()} BoingCars — boingcars.com. {i.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
